import { VbSnackbarService } from 'bag-of-holding-library';
import CostHelpTypeService from '../service/cost-help-type';

export interface CostHelpTypeRequest {
  description: string;
  valueMin: number;
  valueMax: number;
}

export default class CostHelpType {
  id: string;

  description: string;

  valueMin: number;

  valueMax: number;

  active: boolean;

  createdDate: string;

  updatedDate: string;

  createdBy: string;

  updatedBy: string;

  isEditing: boolean = false;

  loadingSave: boolean = false;

  loadingDelete: boolean = false;

  loadingActivate: boolean = false;

  saved: boolean = true;

  constructor(obj: any = {}) {
    this.id = obj.id || '';
    this.description = obj.description || '';
    this.valueMin = obj.valueMin || 0.01;
    this.valueMax = obj.valueMax || 0.01;
    this.active = obj.active !== undefined ? obj.active : true;
    this.createdDate = obj.createdDate || '';
    this.updatedDate = obj.updatedDate || '';
    this.createdBy = obj.createdBy || '';
    this.updatedBy = obj.updatedBy || '';
    this.saved = obj.saved !== undefined ? obj.saved : true;
  }

  get isLoadingSave(): boolean {
    return this.loadingSave;
  }

  get isLoadingDelete(): boolean {
    return this.loadingDelete;
  }

  get isLoadingActivate(): boolean {
    return this.loadingActivate;
  }

  set isLoadingSave(value: boolean) {
    this.loadingSave = value;
  }

  set isLoadingDelete(value: boolean) {
    this.loadingDelete = value;
  }

  set isLoadingActivate(value: boolean) {
    this.loadingActivate = value;
  }

  async update() {
    try {
      this.isLoadingSave = true;
      const data = await CostHelpTypeService.update(this.id, {
        description: this.description,
        valueMin: this.valueMin,
        valueMax: this.valueMax,
      });
      Object.assign(this, data);
      VbSnackbarService.showSuccess('Tipo de ajuda de custo atualizado com sucesso.');
    } catch (error) {
      VbSnackbarService.handleHttpError(error);
    } finally {
      this.isLoadingSave = false;
    }
  }

  async create() {
    try {
      this.isLoadingSave = true;
      const data = await CostHelpTypeService.create({
        description: this.description,
        valueMin: this.valueMin,
        valueMax: this.valueMax,
      });
      Object.assign(this, data);
      VbSnackbarService.showSuccess('Tipo de ajuda de custo criado com sucesso.');
    } catch (error) {
      VbSnackbarService.handleHttpError(error);
    } finally {
      this.isLoadingSave = false;
    }
  }

  async delete() {
    try {
      this.isLoadingDelete = true;
      await CostHelpTypeService.delete(this.id);
      VbSnackbarService.showSuccess('Tipo de ajuda de custo excluída com sucesso.');
      this.active = false;
    } catch (error) {
      VbSnackbarService.handleHttpError(error);
    } finally {
      this.isLoadingDelete = false;
    }
  }

  async activate() {
    try {
      this.isLoadingActivate = true;
      const data = await CostHelpTypeService.activate(this.id);
      Object.assign(this, data);
      VbSnackbarService.showSuccess('Tipo de ajuda de custo ativada com sucesso.');
    } catch (error) {
      VbSnackbarService.handleHttpError(error);
    } finally {
      this.isLoadingActivate = false;
    }
  }
}
